import { observable } from "mobx";
import { apiOperacao } from "../../api";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { decodeUtf8String, downloadBinaryFile, toast_error } from "../../utils";

export class _NFesStore {
  obs = observable({
    imps: [] as any[],
    cnpj_selected: "" as string,
    progressDownload: false as boolean,
    download_danfe_ok: false as boolean,

    selectedTab: "notas" as string,

    selectedEmpresa: newEmpresa() as IEmpresa,
    tasks_relatorio: [],
    length_tasks_relatorio:  0,
  })

  async setBusca(
    empresa: any,
    tipo: string,
    filtro: string,
    date1: string,
    date2: string,
  ): Promise<void> {
    this.obs.cnpj_selected = empresa;

    let params = {
      empresa: empresa,
      filtro: filtro,
      tipo: tipo,
      data1: date1,
      data2: date2
    }
    try {

      let resp = await apiOperacao("notas_xml").post(`/notas_xml/busca`, params)

      if (resp.data == "Conta não Encontrado") {
        toast.warning('Não foram encontrados resultados.', {});

      } else {
        this.obs.imps = [];

        if (resp.data.xmls.length > 0) {

          this.obs.imps = resp.data.xmls?.map((obj) => {
            obj.tipo = tipo;
            // let chaves = obj.map(item => item.chave);
            // console.log(chaves)
            return obj
          });

        } else {
          toast.warning('Não foram encontrados resultados.', {});
        }
      }

    } catch (e) {}
  }

  async cancelar_nota(cnpj: string, dhemi: number, chave: string, tipo: string, filtro: string, uf: string) {

    try {

      let data = {
        cnpj: cnpj,
        dhemi: dhemi,
        chave: chave,
        modelo: tipo,
        tipo: filtro,
        uf: uf
      }

      console.log(data)

      let resp = await apiOperacao("notas_xml").post("/notas_xml/cancelar-nota", data);

      if (resp.data.ok) {

        toast.success('Solicitação de cancelamento realizada com sucesso!', {});

      } else {

        toast.error('Erro ao solicitar cancelamento, tente novamente mais tarde.', {});

      } 
      
    } catch (ex) {

      toast_error(ex, `Erro ao cancelar nota, tente novamente mais tarde.`);

    }

  }

  formatDate(data) {

    const splited = data.split("-").reverse().join("-")

    return splited

  }

  nameFile(documento, empresa, modelo) {

    const razao_social = empresa.replace(/\ /g, "_")
    const cnpj = documento["empresa"]
    const date1 = this.formatDate(documento["data1"])
    const date2 = this.formatDate(documento["data2"])

    const entrada_saida = documento["filtro"].replace("í", "i").toUpperCase()

    const tipo = documento["tipo"].replace("-", "").toUpperCase()

    return `${razao_social}-${cnpj}-${date1}-${date2}-${tipo}-${entrada_saida}${modelo}.zip`

  }

  async handleIndexTask(page: number, cnpj: string, tipo: string, modelo: string) {

    try {

      let data = {
        paged: page,
        limit: 15,
        cnpj: cnpj == "" ? null : cnpj,
        tipo: tipo == "" ? null : tipo,
        modelo: modelo == "" ? null : modelo
      };

      let resp = await apiOperacao("notas_xml").post("/notas_xml/notas-index", data);

      this.obs.tasks_relatorio = [];
      this.obs.length_tasks_relatorio = 0;

      if (resp.data.itens.length > 0) {
        this.obs.tasks_relatorio = resp.data.itens;
        this.obs.length_tasks_relatorio = resp.data.count;
      }

    } catch (ex) {

      toast_error(ex, `Erro ao consultar importação tasks, tente novamente mais tarde.`);

    }

  }

  async handleExport(params: any) {

    try {

      let resp = await apiOperacao("notas_xml").post(`/notas_xml/notas-export`, params)

      if (resp.data.ok) {

        toast.success('Relatório solicitado com sucesso', {});
        return true;

      } else {

        toast.error("Erro ao solicitar Relatório, tente novamente mais tarde.", {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao solicitar Relatório, tente novamente mais tarde.`);

    }

    return false;

  }

  async handleDownloadArquivoRelatorio(id: string, cnpj: string, format: string) {

    try {

      let resp = await apiOperacao("notas_xml").post(`/notas_xml/export/download`, {id: id, format: format}, { responseType: 'blob' });

      if(resp.status == 200){

        const fileName = cnpj + "_relatorio." + format;

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao baixar o arquivo, tente novamente mais tarde.`);

    }

  }

}

export const NFesStore = new _NFesStore();
